_ = require 'underscore'
parseURL = require 'url-parse'

module.exports = class PowerUpSuggester

  constructor: (claimedDomains) ->
    @claimedDomains = claimedDomains

  _hasIPAddressFormat: (s) ->
    return /^[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}$/.test(s)

  _urlIsValid: (url) ->
    return false unless url?

    protocol = url.protocol
    if protocol != 'http:' && protocol != 'https:'
      return false

    if @_hasIPAddressFormat(url.hostname)
      return false

    return true

  _findClaimedPowerUpIdFromNakedDomainByHostname: (hostname) ->
    # We naively find the naked domain by checking if the provided
    # hostname ends with the claimed domain's TLD.

    claimedDomains = Object.keys(@claimedDomains)
    nakedDomain = _.find claimedDomains, (claimedDomain) ->
      beginIndex = hostname.length - claimedDomain.length - 1
      hostname.slice(beginIndex) == "." + claimedDomain

    return @claimedDomains[nakedDomain]

  getPowerUpIdFromClaimedPowerUpDomains: (url) ->
    # Power-Ups can claim domains for unfurling. URLs to be unfurled must
    # have the following heuristics:
    #
    # a) URLs must be fully qualified and include the protocol http://
    #    or https://
    # b) URLs can contain additive sub-domains and will be matched against the
    #    claimed naked domain e.g. https://subdomain.example.com will match
    #    example.com. However, if a power-up has claimed a sub-domain, URLs
    #    containing sub-domains will not be matched against its naked domain.
    # c) URLs cannot be IP addresses as they are not domains
    # d) URLs can include a port number and is eligible for parsing e.g.
    #    https://example.com:8080 will match example.com

    parsedURL = parseURL(url)
    if @_urlIsValid(parsedURL)
      hostname = parsedURL.hostname
      if @claimedDomains[hostname]?
        return @claimedDomains[hostname]
      else
        return @_findClaimedPowerUpIdFromNakedDomainByHostname(hostname)



// WEBPACK FOOTER //
// ./app/scripts/lib/power-up-suggestions/power-up-suggester.coffee